import Vue from 'vue'
import Vuex from 'vuex'
import { ChatUserAPI } from './api/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    userInfo: {
      name: "",
      token: ""
    }
  },
  mutations: {
    saveUserInfo(state, userInfo) {
      state.isLogin = true
      state.userInfo = userInfo
      // 写入本地存储
      localStorage.setItem('user-info', JSON.stringify(userInfo));
    },
    cleanUserInfo(state) {
      state.isLogin = false
      state.userInfo = {}
      localStorage.removeItem('user-info')
    },
    // 从本地缓存加载用户信息
    loadUserInfo(state) {
      const userInfoStr = localStorage.getItem('user-info')
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr)
        state.isLogin = true
        state.userInfo = userInfo
      }
    },
    refreshUserInfo(state) {
      if (state.isLogin) {
        ChatUserAPI.info().then(res => {
          // console.info(res.data)
          state.isLogin = true
          state.userInfo = res
        }).catch(e => {
          state.isLogin = false
          state.userInfo = {}
        })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js